import { render, staticRenderFns } from "./MultiAccountForm.vue?vue&type=template&id=bb54840c"
import script from "./MultiAccountForm.vue?vue&type=script&lang=js"
export * from "./MultiAccountForm.vue?vue&type=script&lang=js"
import style0 from "./MultiAccountForm.vue?vue&type=style&index=0&id=bb54840c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports